export default "__VITE_PUBLIC_ASSET__2f23ccc1__"